import { Box } from '@cloudscape-design/components';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { WikiTreeNode } from './Wiki.logic';

export function useSession() {
  const { currentUser, tenant } = useAuthContext();
  const userId = (currentUser as any)?.uid ?? (currentUser as any)?.id ?? (currentUser as any)?.userId ?? '';
  const role = ((currentUser as any)?.role ??
    (currentUser as any)?.claims?.role ??
    (currentUser as any)?.customClaims?.role ??
    'user') as 'user' | 'admin' | 'god';
  const tenantIdRaw =
    (tenant as any)?.id ??
    (tenant as any)?.tenantId ??
    (tenant as any)?.slug ??
    (tenant as any)?.key ??
    (typeof tenant === 'string' ? tenant : '');
  const tenantId = String(tenantIdRaw || '');
  return { userId, role, tenantId };
}

export function TreeNode({ node }: { node: WikiTreeNode }) {
  return (
    <Box margin={{ bottom: 'xs' }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <Link to={`/wiki/${node.slug}`}>{node.title}</Link>
        {node.status !== 'published' && (
          <Box variant="code" color="text-status-inactive">
            {node.status}
          </Box>
        )}
        {node.pinned && (
          <Box variant="code" color="text-status-success">
            pinned
          </Box>
        )}
      </div>

      {node.children?.length > 0 && (
        <Box margin={{ left: 'l', top: 'xs' }}>
          {node.children.map((child) => (
            <TreeNode key={child.slug} node={child} />
          ))}
        </Box>
      )}
    </Box>
  );
}

export const visibilityOptions = [
  { value: 'public', label: 'Public', description: 'Visible to anyone, even without logging in' },
  { value: 'private', label: 'Private', description: 'Visible only to you and your collaborators' },
];

export const statusOptions = [
  { value: 'draft', label: 'Draft' },
  { value: 'published', label: 'Published' },
];
